/* =============================================
   CART DRAWER BUTTON ENFORCER - TIER 4 JAVASCRIPT
   Ultimate Bulletproof Button Styling Enforcement
   ============================================= */

(function() {
  'use strict';
  
  // BURGUNDY BUTTON WITH QUANTITY SELECTOR STYLE HOVER + WIDTH FIX
  const BUTTON_STYLES = {
    normal: {
      'min-width': 'auto',
      'max-width': 'none',
      'min-height': 'auto',
      'max-height': 'none',
      'width': 'fit-content', // FIXED: User complained "çok geniş button" - was 100%
      'max-width': '240px', // ELEGANT WIDTH CONTROL
      'min-width': '180px', // PREVENT TOO NARROW
      'height': 'auto',
      'padding': '12px 20px',
      'margin': '0 auto 16px auto', // CENTER ALIGNMENT
      'font-size': '1.4rem',
      'font-weight': '600',
      'line-height': '1.2',
      'background': '#922B3E', // SOLID BURGUNDY BACKGROUND
      'color': 'white', // WHITE TEXT FOR CONTRAST
      'border': '2px solid #922B3E',
      'border-radius': '8px',
      'cursor': 'pointer',
      'transition': 'all 0.2s ease', // FASTER TRANSITION LIKE QUANTITY SELECTORS
      'box-shadow': '0 2px 8px rgba(146, 43, 62, 0.15)',
      'position': 'relative',
      'display': 'inline-flex',
      'justify-content': 'center',
      'align-items': 'center',
      'text-align': 'center',
      'text-transform': 'none',
      'letter-spacing': '0.02em',
      'outline': 'none',
      'text-decoration': 'none',
      '-webkit-appearance': 'none',
      'appearance': 'none',
      'box-sizing': 'border-box',
      'opacity': '1',
      'visibility': 'visible',
      'z-index': '10'
    },
    hover: {
      'background': '#922B3E', // KEEP BURGUNDY BACKGROUND
      'color': 'white', // KEEP WHITE TEXT
      'border-color': '#922B3E',
      'transform': 'translateY(-1px)', // QUANTITY SELECTOR STYLE LIFT
      'box-shadow': '0 2px 8px rgba(146, 43, 62, 0.3)' // QUANTITY SELECTOR STYLE SHADOW
    }
  };
  
  // Button selectors in priority order
  const BUTTON_SELECTORS = [
    '#CartDrawer-Checkout.melimelek-cart-checkout-btn',
    '#CartDrawer-Checkout',
    'button[name="checkout"]',
    '[type="submit"][form="CartDrawer-Form"]',
    'cart-drawer .melimelek-cart-checkout-btn',
    'cart-drawer button[name="checkout"]'
  ];
  
  let enforcementActive = false;
  let observer = null;
  
  function applyStyles(element, styles) {
    if (!element) return;
    
    Object.entries(styles).forEach(([property, value]) => {
      try {
        element.style.setProperty(property, value, 'important');
      } catch (e) {
        console.warn(`Failed to set style ${property}: ${value}`, e);
      }
    });
  }
  
  function findButton() {
    for (const selector of BUTTON_SELECTORS) {
      const button = document.querySelector(selector);
      if (button) {
        return button;
      }
    }
    return null;
  }
  
  function enforceButtonStyles() {
    const button = findButton();
    if (!button) return;
    
    // Apply normal styles
    applyStyles(button, BUTTON_STYLES.normal);
    
    // Ensure custom class is present
    if (!button.classList.contains('melimelek-cart-checkout-btn')) {
      button.classList.add('melimelek-cart-checkout-btn');
    }
    
    // Remove conflicting classes
    const conflictingClasses = ['button', 'btn', 'cart__checkout-button'];
    conflictingClasses.forEach(className => {
      if (button.classList.contains(className) && className !== 'melimelek-cart-checkout-btn') {
        button.classList.remove(className);
      }
    });
    
    // Ensure hover functionality
    setupHoverEvents(button);
    
    // Log success
    console.log('✅ Cart drawer button styling enforced successfully');
  }
  
  function setupHoverEvents(button) {
    if (!button) return;
    
    // CRITICAL FIX: Don't clone/replace button - preserves form association and functionality
    // Mark that we've already set up events to avoid duplicates
    if (button.hasAttribute('data-hover-events-setup')) return;
    button.setAttribute('data-hover-events-setup', 'true');
    
    // Add hover event listeners directly to existing button
    button.addEventListener('mouseenter', function() {
      applyStyles(this, BUTTON_STYLES.hover);
    });
    
    button.addEventListener('mouseleave', function() {
      // Reset to normal styles except for hover-specific ones
      Object.entries(BUTTON_STYLES.normal).forEach(([property, value]) => {
        if (!['transform', 'box-shadow'].includes(property)) {
          this.style.setProperty(property, value, 'important');
        }
      });
      this.style.setProperty('transform', 'none', 'important');
      this.style.setProperty('box-shadow', '0 2px 8px rgba(146, 43, 62, 0.15)', 'important');
    });
    
    // Add focus events for accessibility
    button.addEventListener('focus', function() {
      applyStyles(this, BUTTON_STYLES.hover);
    });
    
    button.addEventListener('blur', function() {
      Object.entries(BUTTON_STYLES.normal).forEach(([property, value]) => {
        this.style.setProperty(property, value, 'important');
      });
    });
    
    console.log('✅ Hover events attached safely - button functionality preserved');
  }
  
  function startEnforcement() {
    if (enforcementActive) return;
    enforcementActive = true;
    
    // Initial enforcement
    enforceButtonStyles();
    
    // Set up MutationObserver to watch for DOM changes
    observer = new MutationObserver(function(mutations) {
      let shouldReEnforce = false;
      
      mutations.forEach(function(mutation) {
        // Check if cart drawer was added/modified
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches && (
                node.matches('cart-drawer') ||
                node.matches('#CartDrawer-Checkout') ||
                node.querySelector && node.querySelector('cart-drawer, #CartDrawer-Checkout')
              )) {
                shouldReEnforce = true;
              }
            }
          });
        }
        
        // Check if button attributes were modified
        if (mutation.type === 'attributes' && mutation.target.matches && 
            mutation.target.matches('#CartDrawer-Checkout, .melimelek-cart-checkout-btn')) {
          shouldReEnforce = true;
        }
      });
      
      if (shouldReEnforce) {
        setTimeout(enforceButtonStyles, 100); // Small delay to ensure DOM is settled
      }
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'id']
    });
    
    // Re-enforce every 2 seconds as a backup
    setInterval(enforceButtonStyles, 2000);
    
    console.log('🚀 Cart drawer button enforcer activated');
  }
  
  function stopEnforcement() {
    enforcementActive = false;
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }
  
  // Initialize when DOM is ready
  function initialize() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startEnforcement);
    } else {
      startEnforcement();
    }
    
    // Also start when cart drawer is opened
    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-cart-drawer], .cart-icon, .header__icon--cart')) {
        setTimeout(enforceButtonStyles, 500);
      }
    });
  }
  
  // Handle page lifecycle
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      setTimeout(enforceButtonStyles, 100);
    }
  });
  
  // Handle Shopify section reloads
  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail && (e.detail.sectionId === 'cart-drawer' || e.detail.sectionId.includes('cart'))) {
      setTimeout(enforceButtonStyles, 200);
    }
  });
  
  // Export for debugging
  window.cartDrawerButtonEnforcer = {
    enforce: enforceButtonStyles,
    start: startEnforcement,
    stop: stopEnforcement,
    findButton: findButton
  };
  
  // Initialize immediately
  initialize();
  
})();
